import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON, ICON_COLOR, ICON_SIZE } from 'gcs-common/constants/IconConstants';
import type { Dispatch, SetStateAction } from 'react';
import TicketSearchBar from '../../TicketSearchBar/TicketSearchBar';
import CreatorFilter from './CreatorFilter/CreatorFilter';
import DateFilter from './DateFilter/DateFilter';
import ErpCustomerFilter from './ErpCustomerFilter/ErpCustomerFilter';
import StatusFilter from './StatusFilter/StatusFilter';
import styles from './styles.module.scss';

interface TicketDashboardFiltersProps {
  setShowForm: Dispatch<SetStateAction<boolean>>;
}

const TicketDashboardFilters = (props: TicketDashboardFiltersProps) => {
  const { setShowForm } = props;

  return (
    <div className={styles.filters}>
      <div className={styles.statusFilters}>
        <div className={styles.filterWrapper}>
          <StatusFilter />
        </div>
        <div className={styles.header}>
          <TicketSearchBar />
          <button type="button" className={styles.plus} onClick={() => setShowForm(true)}>
            <IconComponent Icon={ICON.PLUS} color={ICON_COLOR.WHITE} size={ICON_SIZE.SMALL} />
          </button>
        </div>
      </div>
      <div className={styles.inputFilters}>
        <DateFilter />
        <ErpCustomerFilter />
        <CreatorFilter />
      </div>
    </div>
  );
};

export default TicketDashboardFilters;
